var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"menu-header"},[(_vm.icon)?_c('b-icon',{staticClass:"menu-item-icon",attrs:{"icon":_vm.icon,"pack":"fas"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }